import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  ShoppingBag, 
  Mail,
  Briefcase,
  Handshake,
  UsersRound,
  Mic,
  CreditCard,
  Settings,
  Menu,
  X
} from 'lucide-react';

const aicisNavItems = [
  { to: '/aicis', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/aicis/diplomatic-signin', icon: Users, label: 'Diplomatic Sign In' },
  { to: '/aicis/speakers', icon: Mic, label: 'Speakers' },
  { to: '/aicis/event-registration', icon: CreditCard, label: 'Event Registration' },
  { to: '/aicis/affiliate-purchases', icon: ShoppingBag, label: 'Affiliate Purchases' },
  { to: '/aicis/settings', icon: Settings, label: 'Security Settings' },
];

const abvigNavItems = [
  { to: '/abvig', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/abvig/contact-messages', icon: Mail, label: 'Contact Messages' },
  { to: '/abvig/intern-applications', icon: Briefcase, label: 'Intern Applications' },
  { to: '/abvig/partnerships', icon: Handshake, label: 'Partnerships' },
  { to: '/abvig/subscribers', icon: UsersRound, label: 'Subscribers' },
];

export default function Sidebar() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const toggleSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        onClick={toggleSidebar}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-red-600 text-white rounded-lg shadow-lg hover:bg-red-700 transition-colors"
      >
        {isMobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Overlay for mobile */}
      {isMobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-white border-r border-gray-200 flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-gray-800">Dashboard</h1>
            <p className="text-sm text-gray-500">AICIS & ABVIG</p>
          </div>
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-1 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto">
          <div className="p-4">
            <h2 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">AICIS Nigeria 2026</h2>
            <nav className="space-y-1">
              {aicisNavItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                      isActive
                        ? 'bg-red-50 text-red-700'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`
                  }
                >
                  <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                  {item.label}
                </NavLink>
              ))}
            </nav>

            <h2 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mt-6 mb-2">ABVIG</h2>
            <nav className="space-y-1">
              {abvigNavItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsMobileOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                      isActive
                        ? 'bg-red-50 text-red-700'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`
                  }
                >
                  <item.icon className="w-5 h-5 mr-3 flex-shrink-0" />
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}